import React, { FC, memo, useEffect, useState } from "react";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import PaymentSection from "pages/OrderModal/components/PaymentSection";
import PriceSection from "pages/OrderModal/components/PriceSection";
import { IDetailsSectionProps } from "./types";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TuneIcon from "@mui/icons-material/Tune";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import { useAppSelector } from "store/hooks/useAppSelector";
import { defineTime, formatOptions } from "./constants";
import { getRenderableOptions } from "pages/OrderModal/components/OptionsSection/constants";
import { shallowEqual } from "react-redux";
import styles from "./DetailsSection.styled";

const DetailsSection: FC<IDetailsSectionProps> = ({
  onTimeClick,
  onOptionsClick,
  onTaxiClassClick,
}) => {
  const timeData = useAppSelector((state) => state.arriveTime);
  const checkedOptions = useAppSelector(
    (state) => state.options.checkedOptions,
  );
  const customCheckedOptions = useAppSelector(
    (state) => state.options.customCheckedOptions,
  );
  const firstCustomOptions = useAppSelector(
    (state) => state.options.firstCustomOptions,
  );
  const [selectedOptions, setSelectedOptions] =
    useState<string[]>(checkedOptions);
  const taxiClass = useAppSelector((state) => state.taxiClass, shallowEqual);
  const orderCost = useAppSelector((state) => state.orderCost, shallowEqual);

  useEffect(() => {
    if (customCheckedOptions.length || checkedOptions.length) {
      const newCustomCheckedOptions = customCheckedOptions.map((option) =>
        option.Name.toUpperCase(),
      );

      const newCheckedOptions = getRenderableOptions(checkedOptions).map(
        (option) => option.title,
      );

      const selOptionsData = firstCustomOptions
        ? [...newCustomCheckedOptions, ...newCheckedOptions]
        : [...newCheckedOptions, ...newCustomCheckedOptions];

      setSelectedOptions(selOptionsData);
    }
  }, [customCheckedOptions.length, checkedOptions.length]);

  return (
    <List component="nav" sx={styles.listWrap}>
      <ListItemButton onClick={onTimeClick} sx={styles.itemBtn}>
        <ListItemIcon>
          <AccessTimeIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <>
              Час:
              <Typography component="span" sx={styles.time(true)}>
                {` ${defineTime(timeData)}`}
              </Typography>
            </>
          }
        />
      </ListItemButton>
      <ListItemButton onClick={onOptionsClick} sx={styles.itemBtn}>
        <ListItemIcon>
          <TuneIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <>
              Опції:&nbsp;
              <Typography
                component="span"
                sx={styles.time(!!selectedOptions.length)}
              >
                {formatOptions(selectedOptions) || "не вибрано"}
              </Typography>
            </>
          }
        />
      </ListItemButton>
      <PaymentSection />
      <ListItemButton onClick={onTaxiClassClick} sx={styles.itemBtn}>
        <ListItemIcon>
          <LocalTaxiIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <>
              Клас:&nbsp;
              <Typography component="span" sx={styles.time(true)}>
                {taxiClass.value}
              </Typography>
            </>
          }
        />
        <ListItemIcon>
          {orderCost.costDetails.order_cost && <PriceSection />}
        </ListItemIcon>
      </ListItemButton>
    </List>
  );
};

export default memo(DetailsSection);
